import { useNavigate, useSearchParams } from "react-router-dom";
import { IMessageJobMembersProfile } from "@endpoints/types/message.type";
import ThreeDotsVertical from "@assets/svg/ThreeDotsVertical";
import FilterIcon from "@assets/svg/FilterIcon";
import { Search } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import JobMembersCard from "./JobMembersCard";
import { useEffect, useRef } from "react";
import { isNullOrEmpty } from "@utils/helperFunction";
import { EnumUserTypes } from "@utils/constants";
import { fetchJobMessagesProfile } from "@store/actions/message.action";

type MembersProfileSectionProps = {
  selectedContact: any;
  setSelectedContact: any;
};

const MembersProfileSection = (props: MembersProfileSectionProps) => {
  const { selectedContact, setSelectedContact } = props;
  const hasFetched = useRef(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const jobId = searchParams.get("jobId");

  const membersProfile = useSelector(
    (state: RootState) => state.messageReducer?.membersProfile
  );
  const user = useSelector((state: RootState) => state.auth?.user);

  const isRecruiter = user?.userType === EnumUserTypes?.RECRUITER;
  const isReferral = user?.userType === EnumUserTypes?.REFERRAL_AMBASSADOR;
  const userName = user?.firstName + " " + user?.lastName;

  const handleContactSelect = (user) => {
    setSelectedContact(user);
    navigate("/messages");
  };

  useEffect(() => {
    dispatch(fetchJobMessagesProfile())
    if (!hasFetched.current) {
      dispatch(fetchJobMessagesProfile())
      hasFetched.current = true;
    }
  }, []);

  useEffect(() => {
    if (membersProfile?.length) {
      if (!isNullOrEmpty(jobId)) {
        setSelectedContact(
          membersProfile.find((item) =>
            item.appliedJobs.some(
              (appliedJob) => (appliedJob.job?._id || appliedJob.job.jobId) === jobId
            )
          ) || null
        );
      } else {
        setSelectedContact(membersProfile[0]);
        const tempJobId = membersProfile[0]?.appliedJobs[0]?.job._id || membersProfile[0]?.appliedJobs[0]?.job.jobId
        // navigate(
        //   `/messages?jobId=${
        //     isReferral ||
        //     membersProfile[0].userDetails.userType ===
        //       EnumUserTypes.REFERRAL_AMBASSADOR
        //       ? membersProfile[0]?.appliedJobs[0]?.job._id
        //       : membersProfile[0]?.appliedJobs[0]?.jobApplicationId
        //   }`,
        //   {
        //     state: membersProfile[0],
        //   }
        // );
        navigate(
          `/messages?jobId=${tempJobId}`,
          {
            state: membersProfile[0],
          }
        );
        // handleJobClick(membersProfile[0]?.appliedJobs[0])
      }
    }
  }, [membersProfile]);

  // console.log('This is members profile',membersProfile)
  // return null

  return (
    <div className="border-r border-[#ECECEC] w-4/12 flex flex-col">
      {/* Header */}
      <div className="border-b gap-3 border-[#ECECEC] text-xs flex justify-between py-3 px-4 text-primary font-semibold">
        <div className="flex items-center gap-2 rounded-md bg-[#fafafa] px-2 flex-1">
          <Search className={"w-4 h-4"} />
          <input
            placeholder="Search ..."
            className="h-9 flex-1 bg-transparent outline-none font-medium"
          />
        </div>
        <div className="flex items-center gap-2">
          <FilterIcon className={"h-7 w-7"} />
          <ThreeDotsVertical className={"h-6 w-6"} />
        </div>
      </div>
      <div className="overflow-y-auto flex-grow no-scrollbar">
        {membersProfile?.map((item) => {
          return (
            <JobMembersCard
              key={item?.userDetails?._id}
              item={item}
              selectedContact={selectedContact}
              handleContactSelect={handleContactSelect}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MembersProfileSection;
